// extracted by mini-css-extract-plugin
module.exports = {"swiper":"guides-carousel_swiper__hjx_9","center":"guides-carousel_center__2oZ0I"};